const namespace = 'components.simple_list.';

const translations = {
    noResults: `${namespace}no_results`,
    search: `${namespace}search`,
};

export { translations };
